import API from "../api";

export const getQuestions = ({
  params: { page, uuid, page_size, interview, interview_not, for_interview, question } = {},
  signal,
} = {}) => {
  return new Promise((resolve, reject) => {
    try {
      API.get(`/interviews/questions/${uuid ? uuid : ""}`, {
        params: { page, page_size, interview, interview_not, for_interview, question },
        signal,
      })
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject("axios error", err);
        });
    } catch (error) {
      reject("system error", error);
    }
  });
};

export const postQuestion = ({ name, body, type, skills } = {}) => {
  return new Promise((resolve, reject) => {
    try {
      API.post("/interviews/questions/", {
        name,
        body,
        type,
        skills,
      })
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject("axios error", err);
        });
    } catch (error) {
      reject("system error", error);
    }
  });
};

export const patchQuestion = (uuid, { name, body, type, skills } = {}) => {
  return new Promise((resolve, reject) => {
    try {
      API.patch(`/interviews/questions/${uuid}/`, { name, body, type, skills })
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject("axios error", err);
        });
    } catch (error) {
      reject("system error", error);
    }
  });
};

export const deleteQuestion = (uuid) => {
  return new Promise((resolve, reject) => {
    try {
      API.delete(`/interviews/questions/${uuid}/`)
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject("axios error", err);
        });
    } catch (error) {
      reject("system error", error);
    }
  });
};

export const updateQuestionSequence = (uuid, newSequence) => {
  return new Promise((resolve, reject) => {
    try {
      API.patch(`/interviews/interview_questions/${uuid}/`, {
        interview_sequence: newSequence,
      })
        .then((res) => {
          resolve({ success: true, data: res?.data });
        })
        .catch((err) => {
          reject({
            success: false,
            message:
              err.response?.data?.detail ||
              err.response?.data?.error ||
              "Axios error",
          });
        });
    } catch (error) {
      reject({
        success: false,
        message: "System error",
        error,
      });
    }
  });
};

export const getQuestionTypes = async ({ signal } = {}) => {
  try {
    const response = await API.get("/interviews/question_types/", { signal });
    return {
      success: true,
      data: response.data,
    };
  } catch (err) {
    const errorMsg = err || "Failed to fetch question types.";
    return {
      success: false,
      error: errorMsg,
    };
  }
};

export const getSkills = async ({ signal } = {}) => {
  try {
    const response = await API.get("/skills/skills/", { signal });
    return {
      success: true,
      data: response.data,
    };
  } catch (err) {
    const errorMsg = err || "Failed to fetch skills.";
    return {
      success: false,
      error: errorMsg,
    };
  }
};
